export interface Notification {
  // General information
  id: string;
  title: string;
  description: string;
  status: Notification.Status;

  /**
   * Actions defines what happens when the user
   * clicks the notification.
   * A notification can have no actions.
   *
   * Usage:
   *
   *  Internal redirect:
   *    actions: [{
   *      type: 'LINK_INTERNAL',
   *      payload: '/account/profile'
   *    }]
   *
   *  Accepted payload format:
   *    - Must start with a `/`.
   *    - Must have a valid route.
   *    - Optionally can end with a `/`.
   *
   *  External redirect:
   *     actions: [{
   *      type: 'LINK_EXTERNAL',
   *      payload: 'www.google.com'
   *    }]
   *
   *  Accepted format:
   *    - Must not start with `http://`
   *    - Must have `www.` if applicable
   *    - Optionally can start with `https://`
   *    - Optionally can end with a `/`
   *
   * Future Usage:
   *
   *  With a redirect and then the action:
   *    actions: [
   *      {
   *        type: 'LINK_INTERNAL',
   *        payload: '/account/profile'
   *      },
   *      {
   *        type: 'SEQUENCE',
   *        payload: 'open_forgot_password_modal'
   *      },
   *    ]
   *
   *  Abstracted to just the action <= (my preffered way, -santino)
   *    actions: [
   *      {
   *        type: 'SEQUENCE',
   *        payload: 'open_forgot_password_modal'
   *      },
   *    ]
   */
  actions?: Notification.Action[];

  // Time related
  timezone: string;
  time_ago: string;
  viewed_at: string | null;
  created_at: string;
  updated_at: string;
}

export namespace Notification {
  export type Status = 'UNREAD' | 'VIEWED' | 'DELETED';

  export namespace Action {
    export enum Type {
      LINK_INTERNAL = 'LINK_INTERNAL',
      LINK_EXTERNAL = 'LINK_EXTERNAL',
      SEQUENCE = 'SEQUENCE',
    }
  }

  export interface Action {
    type: Notification.Action.Type;
    payload: string;
  }
}
